<template lang="pug">
  v-container(fluid grid-list-lg)
    v-layout(row wrap)
      v-flex(xs12 sm6 md4)
        v-layout(column)

          v-flex
            v-card
              v-toolbar.elevation-0(height="45" color="gray")
                v-toolbar-title
                  h1.subheading {{ $t('labels.locationCode') }}
              v-card-text
                v-layout(column)                  
                  v-layout(row wrap)
                    v-flex {{ $t('labels.code') }}
                    v-spacer
                    v-flex.font-weight-regular.text-xs-right {{ service.csp4.csp4Info.location.code }}
                 
          v-flex
            v-card
              v-toolbar.elevation-0(height="45" color="gray")
                v-toolbar-title
                  h1.subheading {{ $t('labels.business') }}
              v-card-text
                v-layout(column)                  
                  v-layout(row wrap)
                    v-flex {{ $t('labels.HowDidYouFindUs') }}
                    v-spacer
                    v-flex.font-weight-regular.text-xs-right(v-if="location.findUsDetail") {{ location.findUsDetail.selector }}
                    v-flex.font-weight-regular.text-xs-right(v-else) Not Selected
                  v-divider
                  v-layout(row wrap)
                    v-flex {{ $t('labels.businessType') }}
                    v-spacer
                    v-flex.font-weight-regular.text-xs-right(v-if="location.businessTypeDetail") {{ location.businessTypeDetail.selector }}
                    v-flex.font-weight-regular.text-xs-right(v-else) Not Selected

          v-flex
            v-card
              v-toolbar.elevation-0(height="45" color="gray")
                v-toolbar-title
                  h1.subheading {{ $t('labels.organizationInformation') }}         
              v-card-text
                v-layout(column)
                  v-layout(row wrap)
                    v-flex {{ $t('labels.organizationName') }}
                    v-spacer
                    v-flex.font-weight-regular.text-xs-right
                      a(@click="open") {{ organization.organizationName }}
                      v-tooltip.ml-1.pointer(bottom)
                        template(slot='activator')
                          v-icon(color='info' small dark  @click="openWithIcon") open_in_new
                        span Open in new tab
                  v-divider
                  v-layout(row wrap)
                    v-flex {{ $t('labels.ownerName') }}
                    v-spacer
                    v-flex.font-weight-regular.text-xs-right {{ organization.ownerName }}
                  v-divider
                  v-layout(row wrap)
                    v-flex {{ $t('labels.primaryEmail') }}
                    v-spacer
                    v-flex.font-weight-regular.text-xs-right
                      a(@click="sendEmail(organization.primaryEmail)") {{ organization.primaryEmail }}
                  v-divider
                  v-layout(row wrap)
                    v-flex {{ $t('labels.locationCount') }}
                    v-spacer
                    v-flex.font-weight-regular.text-xs-right
                      a(@click="$emit('active', 5)") {{ organization.Stores.length }}

          v-flex(v-if="service.csp4.csp4Info.location.Address")
            v-card
              v-toolbar.elevation-0(height="45" color="gray")
                v-toolbar-title
                  h1.subheading {{ $t('labels.address') }}         
              v-card-text
                v-layout(column)
                  v-layout(row wrap)
                    v-flex {{ $t('labels.phoneNumber') }}
                    v-spacer
                    v-flex.font-weight-regular.text-xs-right {{ service.csp4.csp4Info.location.Address.phoneNumber }}
                  v-divider
                  v-layout(row wrap)
                    v-flex {{ $t('labels.addressLine1') }}
                    v-spacer
                    v-flex.font-weight-regular.text-xs-right {{ service.csp4.csp4Info.location.Address.addressLine1 }}
                  v-divider
                  v-layout(row wrap)
                    v-flex {{ $t('labels.addressLine2') }}
                    v-spacer
                    v-flex.font-weight-regular.text-xs-right {{ service.csp4.csp4Info.location.Address.addressLine2 }}
                  v-divider
                  v-layout(row wrap)
                    v-flex {{ $t('labels.city') }}
                    v-spacer
                    v-flex.font-weight-regular.text-xs-right {{ service.csp4.csp4Info.location.Address.city }}
                  v-divider
                  v-layout(row wrap)
                    v-flex {{ $t('labels.postalCode') }}
                    v-spacer
                    v-flex.font-weight-regular.text-xs-right {{ service.csp4.csp4Info.location.Address.postalCode }}
                  v-divider
                  v-layout(row wrap)
                    v-flex {{ $t('labels.addressLine2') }}
                    v-spacer
                    v-flex.font-weight-regular.text-xs-right {{ service.csp4.csp4Info.location.Address.addressLine2 }}
                  v-divider(v-if="service.csp4.csp4Info.location.Address.Country")
                  v-layout(row wrap)
                    v-flex {{ $t('labels.country') }}
                    v-spacer
                    v-flex.font-weight-regular.text-xs-right {{ service.csp4.csp4Info.location.Address.Country.name }}
                  v-divider(v-if="service.csp4.csp4Info.location.Address.State")
                  v-layout(row wrap)
                    v-flex {{ $t('labels.state') }}
                    v-spacer
                    v-flex.font-weight-regular.text-xs-right {{ service.csp4.csp4Info.location.Address.State.name }}

                  
          v-flex
            v-card
              v-toolbar.elevation-0(height="45" color="gray")
                v-toolbar-title
                  h1.subheading {{ $t('labels.loginInformation') }}         
              v-card-text
                v-layout(column)
                  v-layout(row wrap)
                    
                  v-layout(row wrap)
                    v-flex {{ $t('labels.loginEmail') }}
                    v-spacer
                    v-flex.font-weight-regular.text-xs-right
                      a(@click="sendEmail(organization.loginEmail)") {{ organization.loginEmail }}
                  
                  
                          
      v-flex(xs12 md8)
        v-layout(row wrap)
          v-flex(xs12 md7)
            v-layout(row wrap)
              v-flex(xs12)
                v-layout(column)
                  v-flex
                    v-card
                      v-toolbar.elevation-0(height="45" color="gray")
                        v-toolbar-title
                          h1.subheading {{ $t('labels.locationNote') }}
                        v-spacer
                        toggle-button(v-if="checkRightStatus(48)" @change="updateAlert"  :labels="true" color="red" v-model="location.alertOn" :value="location.alertOn" :sync="true")                       
                        v-btn(small v-if="checkRightStatus(35)" color='info' dark @click="updateNote()" icon)
                          v-icon(small) save
                      v-card-text
                        v-textarea(:rows="rowCount" v-model="location.Notes")  
                 
                  
              
          v-flex(xs12)
            CommentList(:refID="location.storeID" :typeId="1")

          

</template>

<script>
import CommentList from '../../Comment/components/List'
import locationService from '../service.js'
import { mapActions, mapGetters } from 'vuex';

export default {
  data() {
    return {
      rowCount: 6,
    }
  },
  watch: {
    location() {
      this.setPageTitle(this.location.CSPID + " - " + this.location.businessName + '- Store')
    }
  },
  async created(){
  },
  mounted() {
    this.setPageTitle(this.location.CSPID + " - " + this.location.businessName + '- Store')
  },
  methods: {
    ...mapActions('location', ['setLocation', 'setOrgPinNumber']),
    ...mapActions('global', ['setPageTitle', 'sendEmail', 'initOrganization']),
    open() {
      this.$router.push({ path: `/organization/profile/${this.location.organizationID}` })
    },
    openWithIcon() {
      // this.$router.push({ path: `/organization/profile/${this.location.organizationID}` })
      let routeData = this.$router.resolve({ path: `/organization/profile/${this.location.organizationID}` });
      window.open(routeData.href, '_blank');
    },
    updateNote() {
      this.updateStore({Notes: this.location.Notes})
    },
    updateAlert(val) {
      let data = {
        'alertOn': val.value
      }
      this.updateStore(data)
    },
    updateStore(data) {
      console.log('note', data)
      return locationService.updateStore(this.location.storeID, data)
      .then(result => {
        console.log('result', result)
        this.$swal.mixin({
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        }).fire({
          type: 'success',
          title: 'Update Successfully'
        })
        this.setLocation(this.location.storeID)
      })
    },
  },
  components: {
    CommentList,
  },
  computed: {
    ...mapGetters('location', ['location', 'organization', 'service']),
    ...mapGetters('global', ['checkRightStatus'])
  },
}
</script>

<style scoped>
</style>